// extracted by mini-css-extract-plugin
export var boxItems = "_1t-1";
export var boxItemsLg = "_1t-2";
export var button = "_1t-7";
export var buttonHoverless = "_1t-9";
export var buttonLg = "_1t-8";
export var filterGroupBox = "_1t-0";
export var icon = "_1t-3";
export var iconSecondary = "_1t-6";
export var iconWrapper = "_1t-4";
export var iconWrapperLg = "_1t-5";
export var truncatedLabel = "_1t-a";